var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGrn = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21.96,
    viewBox: "0 0 20 21.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,15.484V5a1,1,0,0,1,2,0V16.959a1,1,0,0,1-1.371.929L11.06,16.464,8.939,17.592a2,2,0,0,1-1.879,0L4.94,16.464,1.371,17.888A1,1,0,0,1,0,16.959V1A1,1,0,0,1,2,1V15.484l2.2-.877a2,2,0,0,1,1.68.092L8,15.827,10.121,14.7a2,2,0,0,1,1.68-.092Z",
    transform: "translate(2 4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,6A2,2,0,0,1,0,4V2A2,2,0,0,1,2,0H18a2,2,0,0,1,2,2V4a2,2,0,0,1-2,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H7A1,1,0,0,1,7,2Z",
    transform: "translate(6 9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H7A1,1,0,0,1,7,2Z",
    transform: "translate(6 13)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGrn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grn.b2d44325.svg";
export { ForwardRef as ReactComponent };